<template>
  <div>
    <div class="section py-0 px-5">
      <div class="tile app-title">
        <p class="subtitle is-6">Ajouter un filtre</p>
      </div>
      <b-select
        v-model="selectedFiltreDynamique"
        :placeholder="listeFiltres[0]"
        :disabled="!address"
        expanded>
        <option
          v-for="filtre in listeFiltres"
          :value="filtre"
          :key="filtre">
          {{ filtre }}
        </option>
      </b-select>
    </div>
    <hr>
    <div :key="filtre.id" v-for="filtre in getFiltresDynamiques">
      <component :is="filtre.app" :propriete="filtre.id" :label="filtre.label"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import { TemplateFiltre, DataFiltre, ComputedFiltre, MethodsFiltre } from '@/components/general/baseFiltreDynamique';
import filtreAutoComplete from './filtreAutocomplete';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const filterComponents = {};

[
  { key: 'format', title: 'Format' },
  { key: 'materiel', title: 'Matériel' },
  { key: 'agglomeration', title: 'Agglomération' },
].forEach((el) => {
  filterComponents[el.key] = {
    data: DataFiltre(el.key, el.title),
    computed: ComputedFiltre(VenteFacesLc.mapGetters, 'filtresDynamiquesSpe'),
    methods: MethodsFiltre(VenteFacesLc.mapMutations, VenteFacesLc.mapActions,
      types.REMOVE_FILTER_PROPERTY, types.ADD_FILTER_PROPERTY, 'gestionFiltres'),
    template: TemplateFiltre,
  };
});

export default {
  name: 'ajout-filtre',
  components: {
    appFormat: filterComponents.format,
    appMateriel: filterComponents.materiel,
    appAgglomeration: filterComponents.agglomeration,
    appFiltreAutoComplete: filtreAutoComplete,
  },
  data() {
    return {
      filtreDynamiqueVisible: false,
      listeFiltres: [FILTRE_DYNAMIQUE_VIDE, 'Format', 'Ville', 'Département', 'Matériel', 'Agglomération'],
    };
  },
  watch: {
    selectedFiltreDynamique() {
      const regAccentE = new RegExp('[éèêë]', 'gi');
      const value = this.selectedFiltreDynamique.toLowerCase().replace(regAccentE, 'e');
      if (this.selectedFiltreDynamique !== FILTRE_DYNAMIQUE_VIDE) {
        let valueApp = value;
        if (value === 'ville' || value === 'departement') valueApp = 'filtre-auto-complete';
        this.actionsAjoutFiltresDynamiques({ property: value, valueProperty: { id: value, variable: value, valeur: [], app: 'app-' + valueApp } });
      }
    },
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      address: 'address',
      filtresDynamiques: 'filtresDynamiques',
      getSelectedFiltreDynamique: 'selectedFiltreDynamique',
    }),
    selectedFiltreDynamique: {
      get() {
        return this.getSelectedFiltreDynamique;
      },
      set(value) {
        this.setSelectFiltreDynamique(value);
      },
    },
    getFiltresDynamiques() {
      const tab = this.filtresDynamiques;
      tab.forEach(el => {
        if (el.id === 'ville') el.label = 'Ville';
        if (el.id === 'departement') el.label = 'Département';
      });
      return tab;
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setSelectFiltreDynamique: types.SELECT_FILTRE_DYNAMIQUE,
    }),
    ...VenteFacesLc.mapActions({
      actionsAjoutFiltresDynamiques: 'ajoutFiltresDynamiques',
    }),
  },
};
</script>

<style scoped>

select {
  padding-left:10px;
  padding-right: 10px;
  -webkit-appearance: none;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  color:#5E738B;
}

select:disabled{
  background-color: rgba(200, 200, 200, 0.2);
  border:none;
}

select:hover{
  border-color: #bfbfbf;
}

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/ajoutFiltre.vue